import { Box } from "@mui/material";

import { useFloatingBubbles } from "../../context/floating-bubbles/FloatingBubblesContext";
import { useChatDock } from "./ChatDockContext";
import { ChatDockOverflowMenu } from "./ChatDockOverflowMenu";
import { ChatDockWindow } from "./ChatDockWindow";
import { DOCK_GAP, useChatDockLayout } from "./useChatDockLayout";

export function ChatDock() {
  const { openChats, focusedKey } = useChatDock();
  const { chatDockZIndex, raiseContactCenter } = useFloatingBubbles();
  const { visible, overflow, windowWidth, rightOffset, windowHeight } = useChatDockLayout(openChats);

  if (openChats.length === 0) return null;

  return (
    <Box
      data-chat-dock
      onMouseDown={raiseContactCenter}
      sx={{
        position: "fixed",
        bottom: 0,
        right: rightOffset,
        display: "flex",
        alignItems: "flex-end",
        gap: `${DOCK_GAP}px`,
        zIndex: chatDockZIndex,
        pointerEvents: "none",
        "& > *": { pointerEvents: "auto" },
      }}
      role="region"
      aria-label="Open chats"
      data-prevent-parent-trigger="true"
    >
      {overflow.length > 0 && <ChatDockOverflowMenu chats={overflow} />}

      {visible.map((chat) => (
        <ChatDockWindow
          key={chat.key}
          chat={chat}
          width={windowWidth}
          height={windowHeight}
          isFocused={focusedKey === chat.key}
        />
      ))}
    </Box>
  );
}
